"use strict"

// FAQ ACCORDEON

document.addEventListener('DOMContentLoaded', () => {
  const faqSections = document.querySelectorAll('.faq');

  if (!faqSections.length) return;

  faqSections.forEach((faqSection) => {
    const items = faqSection.querySelectorAll('[data-faq-item]');

    if (!items.length) return;

    const closeItem = (item) => {
      const trigger = item.querySelector('[data-faq-trigger]');
      const content = item.querySelector('[data-faq-content]');

      if (!trigger || !content) return;

      item.classList.remove('is-active');
      trigger.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = '0px';
    };

    const openItem = (item) => {
      const trigger = item.querySelector('[data-faq-trigger]');
      const content = item.querySelector('[data-faq-content]');

      if (!trigger || !content) return;

      item.classList.add('is-active');
      trigger.setAttribute('aria-expanded', 'true');
      content.style.maxHeight = content.scrollHeight + 'px';
    };

    items.forEach((item) => {
      const trigger = item.querySelector('[data-faq-trigger]');
      const content = item.querySelector('[data-faq-content]');

      if (!trigger || !content) return;

      item.classList.remove('is-active');
      trigger.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = '0px';

      trigger.addEventListener('click', () => {
        const isActive = item.classList.contains('is-active');

        items.forEach((currentItem) => {
          closeItem(currentItem);
        });

        if (!isActive) {
          openItem(item);
        }
      });
    });

    window.addEventListener('resize', () => {
      const activeItem = faqSection.querySelector('[data-faq-item].is-active');
      if (!activeItem) return;

      const activeContent = activeItem.querySelector('[data-faq-content]');
      if (!activeContent) return;

      activeContent.style.maxHeight = activeContent.scrollHeight + 'px';
    });
  });
});

// COLLECTION FILTER ACCORDION

document.addEventListener('DOMContentLoaded', function () {
  const groups = document.querySelectorAll('[data-filter-accordion]');

  if (!groups.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const expand = (details, content) => {
    details.dataset.animating = 'true';
    details.open = true;

    if (reduceMotion) {
      content.style.height = 'auto';
      details.dataset.animating = 'false';
      return;
    }

    const target = content.scrollHeight;
    content.style.height = '0px';
    // force reflow so the browser registers the starting height
    void content.offsetHeight;
    content.style.height = target + 'px';

    const onEnd = (event) => {
      if (event.propertyName !== 'height') return;
      content.style.height = 'auto';
      details.dataset.animating = 'false';
      content.removeEventListener('transitionend', onEnd);
    };
    content.addEventListener('transitionend', onEnd);
  };

  const collapse = (details, content) => {
    details.dataset.animating = 'true';

    if (reduceMotion) {
      details.open = false;
      content.style.height = '';
      details.dataset.animating = 'false';
      return;
    }

    content.style.height = content.scrollHeight + 'px';
    void content.offsetHeight;
    content.style.height = '0px';

    const onEnd = (event) => {
      if (event.propertyName !== 'height') return;
      details.open = false;
      content.style.height = '';
      details.dataset.animating = 'false';
      content.removeEventListener('transitionend', onEnd);
    };
    content.addEventListener('transitionend', onEnd);
  };

  groups.forEach((details) => {
    const summary = details.querySelector('summary');
    const content = details.querySelector('[data-filter-content]');

    if (!summary || !content) return;

    if (details.open) {
      content.style.height = 'auto';
    }

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      if (details.dataset.animating === 'true') return;

      if (details.open) {
        collapse(details, content);
      } else {
        expand(details, content);
      }
    });
  });
});

// COLLECTION MOBILE FILTERS PANEL

document.addEventListener('DOMContentLoaded', function () {
  const compactFiltersQuery = window.matchMedia('(max-width: 1180px)');

  document.querySelectorAll('[data-collection-filter]').forEach(function (root) {
    const toggle = root.querySelector('[data-collection-filters-toggle]');
    const panel = root.querySelector('[data-collection-filters-panel]');
    const inner = root.querySelector('[data-collection-filters-panel-inner]');

    if (!toggle || !panel || !inner) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let isAnimating = false;

    const usesCompactFilters = () => compactFiltersQuery.matches;

    const resetWide = () => {
      isAnimating = false;
      panel.classList.remove('is-open');
      panel.style.height = '';
      toggle.setAttribute('aria-expanded', 'false');
    };

    const resetCompact = () => {
      isAnimating = false;
      panel.classList.remove('is-open');
      panel.style.height = '';
      toggle.setAttribute('aria-expanded', 'false');
    };

    const expand = () => {
      if (isAnimating || !usesCompactFilters()) return;

      panel.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');

      if (reduceMotion) {
        panel.style.height = 'auto';
        return;
      }

      isAnimating = true;
      const target = inner.scrollHeight;
      panel.style.height = '0px';
      void panel.offsetHeight;
      panel.style.height = target + 'px';

      const onEnd = (event) => {
        if (event.propertyName !== 'height') return;
        panel.style.height = 'auto';
        isAnimating = false;
        panel.removeEventListener('transitionend', onEnd);
      };

      panel.addEventListener('transitionend', onEnd);
    };

    const collapse = () => {
      if (isAnimating || !usesCompactFilters()) return;

      toggle.setAttribute('aria-expanded', 'false');

      if (reduceMotion) {
        panel.classList.remove('is-open');
        panel.style.height = '';
        return;
      }

      isAnimating = true;
      panel.style.height = panel.scrollHeight + 'px';
      void panel.offsetHeight;
      panel.style.height = '0px';

      const onEnd = (event) => {
        if (event.propertyName !== 'height') return;
        panel.classList.remove('is-open');
        panel.style.height = '';
        isAnimating = false;
        panel.removeEventListener('transitionend', onEnd);
      };

      panel.addEventListener('transitionend', onEnd);
    };

    toggle.addEventListener('click', () => {
      if (!usesCompactFilters()) return;

      if (panel.classList.contains('is-open')) {
        collapse();
      } else {
        expand();
      }
    });

    compactFiltersQuery.addEventListener('change', () => {
      if (usesCompactFilters()) {
        resetCompact();
      } else {
        resetWide();
      }
    });
  });
});

// COLLECTION PRICE RANGE SLIDER

document.addEventListener('DOMContentLoaded', () => {
  const priceRanges = document.querySelectorAll('[data-price-range]');

  if (!priceRanges.length) return;

  priceRanges.forEach((container) => {
    const minInput = container.querySelector('[data-price-min]');
    const maxInput = container.querySelector('[data-price-max]');
    const minRange = container.querySelector('[data-price-slider-min]');
    const maxRange = container.querySelector('[data-price-slider-max]');
    const fill = container.querySelector('[data-price-slider-fill]');

    const rangeMin = parseFloat(container.dataset.rangeMin) || 0;
    const rangeMax = parseFloat(container.dataset.rangeMax);

    if (!minInput || !maxInput || !minRange || !maxRange || !fill || !Number.isFinite(rangeMax) || rangeMax <= rangeMin) {
      return;
    }

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const roundPrice = (value) => Math.round(value * 100) / 100;

    const formatPrice = (value) => roundPrice(value).toFixed(2);

    const parseInputValue = (input, fallback) => {
      const value = parseFloat(input.value);
      return Number.isFinite(value) ? roundPrice(value) : fallback;
    };

    const updateFill = (min, max) => {
      const span = rangeMax - rangeMin;
      const percentMin = ((min - rangeMin) / span) * 100;
      const percentMax = ((max - rangeMin) / span) * 100;

      fill.style.left = percentMin + '%';
      fill.style.width = (percentMax - percentMin) + '%';
    };

    const syncFromSliders = () => {
      let min = roundPrice(parseFloat(minRange.value));
      let max = roundPrice(parseFloat(maxRange.value));

      if (min > max) {
        if (document.activeElement === minRange) {
          min = max;
        } else {
          max = min;
        }
      }

      minRange.value = formatPrice(min);
      maxRange.value = formatPrice(max);
      minInput.value = min <= rangeMin ? '' : formatPrice(min);
      maxInput.value = max >= rangeMax ? '' : formatPrice(max);
      updateFill(min, max);
    };

    const syncFromInputs = (formatFields = false) => {
      let min = parseInputValue(minInput, rangeMin);
      let max = parseInputValue(maxInput, rangeMax);

      min = clamp(min, rangeMin, rangeMax);
      max = clamp(max, rangeMin, rangeMax);

      if (min > max) {
        if (document.activeElement === minInput) {
          max = min;
        } else {
          min = max;
        }
      }

      minRange.value = formatPrice(min);
      maxRange.value = formatPrice(max);

      if (formatFields) {
        minInput.value = min <= rangeMin ? '' : formatPrice(min);
        maxInput.value = max >= rangeMax ? '' : formatPrice(max);
      }

      updateFill(min, max);
    };

    minRange.addEventListener('input', syncFromSliders);
    maxRange.addEventListener('input', syncFromSliders);
    minInput.addEventListener('input', () => syncFromInputs(false));
    maxInput.addEventListener('input', () => syncFromInputs(false));
    minInput.addEventListener('change', () => syncFromInputs(true));
    maxInput.addEventListener('change', () => syncFromInputs(true));

    syncFromInputs(true);
  });
});

// CART COUNT

async function fetchCartItemCount() {
  const response = await fetch('/cart.js', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch cart count');
  }

  const cart = await response.json();
  return Number(cart.item_count || 0);
}

function updateCartCountBadge(itemCount) {
  const badges = document.querySelectorAll('[data-cart-count]');
  if (!badges.length) return;

  badges.forEach((badge) => {
    badge.textContent = String(itemCount);
    badge.classList.toggle('is-hidden', itemCount <= 0);
  });
}

async function syncCartCountBadge() {
  try {
    const itemCount = await fetchCartItemCount();
    updateCartCountBadge(itemCount);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Cart badge sync error:', error);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  syncCartCountBadge();
});

document.addEventListener('cart:refresh', () => {
  syncCartCountBadge();
});
